"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asProperName = exports.asLastSuffixFirstMiddle = void 0;
var _asTitleCase = require("./asTitleCase");
var _string = require("../type-checks/string");
var defaultNameObjectKeys = ["first", "middle", "last", "suffix"];
var suffixList = ["JR", "SR", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
var asProperName = exports.asProperName = function asProperName(nameObj) {
  var nameObjectKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultNameObjectKeys;
  // Define full name array;
  var properName = [];
  // Iterate over keys;
  nameObjectKeys.forEach(function (key) {
    if ((0, _string.isStringOfLength)(nameObj[key])) {
      var titleCaseConfig = {
        capitalizeAfter: ["-", "'"],
        excludes: key === "suffix" ? suffixList.slice(2) : []
      };
      var nameObjKey = nameObj[key].trim();
      properName.push((0, _asTitleCase.asTitleCase)(nameObjKey, titleCaseConfig));
    }
  });
  // Return proper name;
  return properName.join(" ").trim();
};
var asLastSuffixFirstMiddle = exports.asLastSuffixFirstMiddle = function asLastSuffixFirstMiddle(nameObj) {
  // Define full name array;
  var properName = [asProperName(nameObj, ["last", "suffix"]), asProperName(nameObj, ["first", "middle"])];
  return properName.join(", ");
};